import { render, staticRenderFns } from "./Iso.vue?vue&type=template&id=f79ce10c&scoped=true"
import script from "./Iso.vue?vue&type=script&lang=js"
export * from "./Iso.vue?vue&type=script&lang=js"
import style0 from "./Iso.vue?vue&type=style&index=0&id=f79ce10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79ce10c",
  null
  
)

export default component.exports